const claimTypes = {
    MODULE_ACCESS: "ModuleAccess",
    FIELD_ACCESS: "FieldAccess"
}

export default claimTypes;